export default "__VITE_ASSET__CKCjXB6$__"